/**
 * Mapbox basemap URL for react-map-gl `mapStyle`.
 * (Not the React `style` prop — that’s the map container’s width/height CSS.)
 */
export const MAPBOX_MAP_STYLE = 'mapbox://styles/mapbox/light-v11'
